import { Box } from '@mui/material';
import * as React from 'react';

export interface IMobileRequestsTabLabelProps {
    title: string;
    unreadMessageCount: number;
}

export default function MobileRequestsTabLabel(props: IMobileRequestsTabLabelProps) {
    const { title, unreadMessageCount } = props;

    React.useEffect(() => {
    }, []);

    return (<Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
        <Box >{title}</Box>
        <Box>{unreadMessageCount > 0 ? <Box
            ml={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="18px"
            height="18px"
            borderRadius="50%"
            sx={{ backgroundColor: '#404040', color: 'white'/* '#FFC600' */, fontSize: '10px', fontWeight: 'bold' }}
        >
            {unreadMessageCount}
        </Box>
            : ''
        }</Box>
    </Box>);
}
